import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-video',
  templateUrl: './video.component.html',
  styleUrls: ['./video.component.css', './video.component.scss']
})
export class VideoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

  goToMinute(time: string) {
    const iframe = document.getElementById('videoIframe') as HTMLIFrameElement;

    const newSrc = this.updateQueryStringParameter(
      iframe.src,
      't',
      time.toString()
    );

    iframe.src = newSrc;
  }

  private updateQueryStringParameter(uri: string, key: string, value: string) {
    const re = new RegExp(`([?&])${key}=.*?(&|$)`, 'i');
    const separator = uri.indexOf('?') !== -1 ? '&' : '?';

    if (uri.match(re)) {
      return uri.replace(re, `$1${key}=${value}$2`);
    } else {
      return `${uri}${separator}${key}=${value}`;
    }
  }
}
